import React from 'react';
import { motion } from 'framer-motion';
import { FaBrain, FaMobileAlt, FaChartLine, FaShieldAlt, FaFlask, FaUsers } from 'react-icons/fa';
import './Features.css';

const Features = () => {
  const features = [
    {
      icon: FaFlask,
      title: "Research-First Mindset",
      description: "We're not launching a product. We're running carefully designed experiments to figure out what signals actually matter for predicting migraines."
    },
    {
      icon: FaMobileAlt,
      title: "Simple Data Collection",
      description: "Participants use a lightweight app to log how they're feeling each day. No complex setup, just a quick daily check-in."
    },
    {
      icon: FaChartLine,
      title: "Looking for Real Signals",
      description: "We're exploring which combinations of physiological and environmental data correlate with migraine onset and which don't."
    },
    {
      icon: FaShieldAlt,
      title: "Your Data, Protected",
      description: "All data is anonymized and handled with full research ethics. Participation is voluntary and you can stop at any time."
    },
    {
      icon: FaBrain,
      title: "Iterating on the Design",
      description: "Each round of testing teaches us something. We refine our measurement protocol based on what works in practice, not just in theory."
    },
    {
      icon: FaUsers,
      title: "Open to Collaboration",
      description: "We welcome healthcare professionals and researchers who want to contribute to the study design or interpret findings alongside us."
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  };

  return (
    <section id="features" className="features section bg-light">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">Our Approach</h2>
          <p className="section-subtitle">
            We're in the early stages, deliberately so. Getting the science right now
            means building something that actually works later.
          </p>
        </motion.div>

        <motion.div
          className="features-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {features.map((feature, index) => (
            <motion.div
              key={index}
              className="feature-card"
              variants={itemVariants}
              whileHover={{
                y: -2,
                transition: { duration: 0.2 }
              }}
            >
              <div className="feature-icon">
                <feature.icon />
              </div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Features;
